import type { Namespace } from '../sessions';

const TOKEN_COOKIE_PREFIXES: Record<Namespace, string> = {
  web: '__aia_web',
};

type CookieNamesResponse = {
  accessTokenName: string;
  currencyCookieName: string;
  localeCookieName: string;
  refreshTokenName: string;
};

export function getCookieNames(namespace: Namespace): CookieNamesResponse {
  const prefix = TOKEN_COOKIE_PREFIXES[namespace];

  return {
    accessTokenName: `${prefix}_token__`,
    currencyCookieName: `${prefix}_currency`,
    localeCookieName: `${prefix}_locale`,
    refreshTokenName: `${prefix}_refresh_token__`,
  };
}
